import Loadable from 'react-loadable';

const components = {
  Root: Loadable({
    loader: () => import(/* webpackChunkName: "Root" */ '@screens/Root/Root'),
    loading: () => null,
  }),
  Login: Loadable({
    loader: () =>
      import(/* webpackChunkName: "Login" */ '@screens/Login/Login'),
    loading: () => null,
  }),
  LinkShortner: Loadable({
    loader: () =>
      import(
        /* webpackChunkName: "LinkShortner" */ '@screens/LinkShortner/Container'
      ),
    loading: () => null,
  }),
  LinkGenerator: Loadable({
    loader: () =>
      import(
        /* webpackChunkName: "LinkGenerator" */ '@screens/LinkGenerator/Container'
      ),
    loading: () => null,
  }),
  Home: Loadable({
    loader: () =>
      import(/* webpackChunkName: "Home" */ '@screens/Home/Container'),
    loading: () => null,
  }),
  ModalRedirect: Loadable({
    loader: () =>
      import(
        /* webpackChunkName: "ModalRedirect" */ '@screens/ModalRedirect/Container'
      ),
    loading: () => null,
  }),
  ListLives: Loadable({
    loader: () =>
      import(/* webpackChunkName: "ListLives"*/ '@screens/ListLives/ListLives'),
    loading: () => null,
  }),
  ModalManagement: Loadable({
    loader: () =>
      import(
        /* webpackChunkName: "ListLives"*/ '@screens/ModalManagement/ModalManagement'
      ),
    loading: () => null,
  }),
  ListPrograms: Loadable({
    loader: () =>
      import(
        /* webpackChunkName: "ListPrograms"*/ '@screens/ListPrograms/ListPrograms'
      ),
    loading: () => null,
  }),
  RegisterNewLive: Loadable({
    loader: () =>
      import(
        /* webpackChunkName: "registerNewLive"*/ '@screens/RegisterNewLive/Container'
      ),
    loading: () => null,
  }),
  CreateBanner: Loadable({
    loader: () =>
      import(
        /* webpackChunkName: "createBanner"*/ '@screens/CreateBanner/CreateBanner'
      ),
    loading: () => null,
  }),
  PublishBanner: Loadable({
    loader: () =>
      import(
        /* webpackChunkName: "publishBanner"*/ '@screens/PublishBanner/PublishBanner'
      ),
    loading: () => null,
  }),
  ListBanners: Loadable({
    loader: () =>
      import(
        /* webpackChunkName: "Banner" */ '@screens/ListBanners/ListBanners'
      ),
    loading: () => null,
  }),
  CreateEditProgram: Loadable({
    loader: () =>
      import(
        /* webpackChunkName: "Bonus" */ '@screens/CreateEditProgram/CreateEditProgram'
      ),
    loading: () => null,
  }),
  PushNotifications: Loadable({
    loader: () =>
      import(
        /* webpackChunkName: "PushNotifications" */ '@screens/PushNotifications'
      ),
    loading: () => null,
  }),
  PushMessage: Loadable({
    loader: () =>
      import(
        /* webpackChunkName: "PushMessage" */ '../screens/PushMessage/PushMessage'
      ),
    loading: () => null,
  }),
  Partnership: Loadable({
    loader: () => import('@screens/Partnership/Partnership'),
    loading: () => null,
  }),

  CreatePartner: Loadable({
    loader: () => import('@screens/Partnership/CreatePartner/CreatePartner'),

    loading: () => null,
  }),

  Transactions: Loadable({
    loader: () =>
      import(/* webpackChunkName: "Transactions" */ '../screens/Transactions'),
    loading: () => null,
  }),
  TransactionInfo: Loadable({
    loader: () =>
      import(
        /* webpackChunkName: "TransactionInfo" */ '../screens/TransactionInfo'
      ),
    loading: () => null,
  }),
  ListCaptions: Loadable({
    loader: () =>
      import(
        /* webpackChunkName: "Captions" */ '../screens/Captions/ListCaptions'
      ),
    loading: () => null,
  }),
  CreateCaptions: Loadable({
    loader: () =>
      import(
        /* webpackChunkName: "Captions" */ '../screens/Captions/CreateCaptions'
      ),
    loading: () => null,
  }),
  ListCaptionsByProgram: Loadable({
    loader: () =>
      import(
        /* webpackChunkName: "Captions" */ '../screens/Captions/ListCaptionsByProgram'
      ),
    loading: () => null,
  }),
};

function preloadWith(names) {
  for (let i = 0; i < names.length; i += 1) {
    const name = names[i];
    const component = components[name];

    if (component) {
      component.preload();
    } else {
      throw new Error(
        `TypeError: Cannot preload '${name}' of undefined. Are you sure this component exists?`
      );
    }
  }
}

function preload(...keys) {
  if (!keys.length) {
    // Preload all components when array of keys are empty
    preloadWith(Object.keys(components));
  } else {
    preloadWith(keys);
  }
}

export default {
  ...components,
  preload,
};
